
<div [ngClass]="isLeftPanelHide ? 'maincomp-expand' : 'maincomp'"  >
    <div class="container-fluid">
        <div class="row ">
            <div class="col-6"  >
                <app-member-editor (edittedImage)="edittedImage.emit($event)"></app-member-editor>
            </div>
            <div class="col-6"  >
                <!-- <div style="background-color: yellowgreen !important;">
                    Event Area
                </div> -->

                <!-- <Temp event border> -->
                <div class="temp-event-border">
                </div>
            </div>
        </div>
</div>
</div>